import { NgModule } from '@angular/core';
import GoogleMapPlacesService from './google-map-places.service';

@NgModule({
  providers: [GoogleMapPlacesService],
})
export default class GoogleMapPlacesServiceModule {}
